import React, { ReactNode } from 'react';
import Box from '../../Box';

const ModalContent: React.FC<{ children: ReactNode}> = ({ children})=> {
  return (
    <Box boxSize='big' css={{overflowY: 'auto', flex: '1 1 auto', padding: '16px 24px'}}>{children}</Box>
  )
}

export default ModalContent;